import styled from 'styled-components'

export const TableDefaultItemWrapper = styled.tr`
  color: ${({ theme }) => theme.colors.black1};
  line-height: 24px;
`
